import { Location } from "../../Master/Location/location";
import { ProductDetail } from "../../Master/Product/product-detail";
import { User } from "../../user";
import { ProductCostingMaterial } from "./product-costing-material";
import { ProductCostingPackaging } from "./product-costing-packaging";
import { ProductCostingProcess } from "./product-costing-process";

export class ProductCosting {

    refNo: string;
    date: string;

    productCode: number;
    rate: number;
    weight: number;
    batchSize: number;
    totalMaterialQty: number;
    totalPackagingQty: number;

    costOfMaterialBatch: number;
    costOfPackagingBatch: number;
    productionLoss: number;
    overheadLoss: number;
    overallCostBatch: number;
    overallWeightBatch: number;

    convertToUnit: string;
    fromLocationCode: number;

    // productCostingMaterials: ProductCostingMaterial[] = [];
    productCostingRawMaterials: ProductCostingMaterial[] = [];
    productCostingFinishedMaterials: ProductCostingMaterial[] = [];
    productCostingSemiFinishedMaterials: ProductCostingMaterial[] = [];
    productCostingPackagings: ProductCostingPackaging[] = [];

    productDetail: ProductDetail;
    fromLocation: Location;
    user: User;
}
